import { logger } from '@jobilla/instrumentation'
import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { postHogConfig } from './postHogConfig'

export function PostHogProviderWrapper({ children }: PropsWithChildren) {
	if (!postHogConfig.api_key) {
		return <>{children}</>
	}

	return (
		<PostHogProvider apiKey={postHogConfig.api_key} options={postHogConfig.options}>
			<AnalyticsSuperProperties />
			{children}
		</PostHogProvider>
	)
}

function AnalyticsSuperProperties() {
	const { i18n } = useTranslation('common')

	useEffect(() => {
		logger.register({ app: 'candidate-center', preferred_language: i18n.language })
	}, [i18n.language])

	return null
}
